import React, { useEffect } from "react";
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import { useTranslation, Trans } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
const Payment = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const isMobile = useMediaQuery("(max-width:600px)");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";

  // Common table styles
  const tableContainerStyles = {
    marginBottom: 3,
    marginTop: 2,
    overflowX: "hidden",
    "&::-webkit-scrollbar": { display: "none" },
    "@media (max-width: 600px)": {
      mx: 0,
      width: "100%",
      minWidth: "unset",
    },
  };

  const tableStyles = {
    tableLayout: "fixed",
    width: "100%",
    minWidth: 300,
    "@media (min-width: 600px)": { minWidth: 600 },
  };

  const headerCellStyles = {
    fontWeight: "bold",
    fontSize: { xs: "0.7rem", sm: "0.9rem", lg: "1rem" },
    padding: { xs: "6px", sm: "12px" },
    lineHeight: 1.2,
    width: { xs: "40%", sm: "30%" },
  };

  const bodyCellStyles = {
    fontSize: { xs: "0.65rem", sm: "0.85rem", lg: "0.95rem" },
    padding: { xs: "4px", sm: "8px" },
    wordWrap: "break-word",
    lineHeight: 1.2,
  };

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1100px",
        margin: "auto",
        marginTop: "60px",
        "@media (min-width: 1024px)": { marginTop: "80px" },
      }}
    >
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        <Trans
          i18nKey="PricingList"
          components={{
            0: <strong style={{ color: "#D84040" }} />,
          }}
        />
      </Typography>
      {/* Intro Section */}
      <Typography
        style={{ direction, textAlign }}
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.1rem",
          fontWeight: 400,
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.4rem",
            fontWeight: 500,
            marginBottom: "30px",
          },
        }}
      >
        <Trans
          i18nKey="pricing.intro"
          components={{
            0: <strong style={{ color: "#1976d2" }} />,
          }}
        />
      </Typography>

      {/* Section 1 */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        <Trans
          i18nKey="pricing.receivingGoodsHeadOffice"
          components={{
            0: <strong style={{ color: "#D84040" }} />,
          }}
        />
      </Typography>

      {/* //TODO: Table 1 */}
      <TableContainer component={Paper} sx={tableContainerStyles}>
        <Table sx={tableStyles}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#C4D9FF" }}>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing1.tableHeaders.weightRange")}
              </TableCell>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing1.tableHeaders.priceCard")}
              </TableCell>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing1.tableHeaders.priceCash")}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {[
              {
                range: t("pricing1.tableRows.500kgOrMore"),
                price: "£1.10",
                notes: "£1.15",
              },
              {
                range: t("pricing1.tableRows.150kgTo499kg"),
                price: "£1.15",
                notes: "£1.20",
              },
              {
                range: t("pricing1.tableRows.50kgTo149kg"),
                price: "£1.20",
                notes: "£1.25",
              },
              {
                range: t("pricing1.tableRows.1kgTo49kg"),
                price: "£1.25",
                notes: "£1.30",
              },
            ].map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                }}
              >
                <TableCell
                  component="th"
                  align="center"
                  scope="row"
                  sx={bodyCellStyles}
                >
                  {row.range}
                </TableCell>
                <TableCell align="center" sx={bodyCellStyles}>
                  {row.price}
                </TableCell>
                <TableCell align="center" sx={bodyCellStyles}>
                  {row.notes}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Section 2 */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        <Trans
          i18nKey="pricing.receivingGoodsAgent"
          components={{
            0: <strong style={{ color: "#D84040" }} />,
          }}
        />
      </Typography>
      {/* //TODO: Table 2 */}

      <TableContainer component={Paper} sx={tableContainerStyles}>
        <Table sx={tableStyles}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#C4D9FF" }}>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing2.tableHeaders.weightRange")}
              </TableCell>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing2.tableHeaders.priceCard")}
              </TableCell>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "33%" }}
              >
                {t("pricing2.tableHeaders.priceCash")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              {
                range: t("pricing2.tableRows.500kgOrMore"),
                price: "£1.15",
                notes: "£1.20",
              },
              {
                range: t("pricing2.tableRows.150kgTo499kg"),
                price: "£1.20",
                notes: "£1.25",
              },
              {
                range: t("pricing2.tableRows.50kgTo149kg"),
                price: "£1.25",
                notes: "£1.30",
              },
              {
                range: t("pricing2.tableRows.1kgTo49kg"),
                price: "£1.30",
                notes: "£1.35",
              },
            ].map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                }}
              >
                <TableCell
                  component="th"
                  align="center"
                  scope="row"
                  sx={bodyCellStyles}
                >
                  {row.range}
                </TableCell>
                <TableCell align="center" sx={bodyCellStyles}>
                  {row.price}
                </TableCell>
                <TableCell align="center" sx={bodyCellStyles}>
                  {row.notes}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Section 3 */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        <Trans
          i18nKey="pricing.receivingGoodsAgent2"
          components={{
            0: <strong style={{ color: "#D84040" }} />,
          }}
        />
      </Typography>
      {/* //TODO: Table 3 */}
      {/* Table 3 */}

      <TableContainer component={Paper} sx={tableContainerStyles}>
        <Table sx={tableStyles}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#C4D9FF" }}>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "50%" }}
              >
                {t("collection.tableHeaders.weight")}
              </TableCell>
              <TableCell
                sx={{ ...headerCellStyles, textAlign: "center", width: "50%" }}
              >
                {t("collection.tableHeaders.fee")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              {
                range: t("collection.tableRows.moreThan150Kg"),
                price: t("collection.tableRows.free"),
              },
              { range: t("collection.tableRows.lessThan150Kg"), price: "£15" },
            ].map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                }}
              >
                <TableCell
                  component="th"
                  align="center"
                  scope="row"
                  sx={bodyCellStyles}
                >
                  {row.range}
                </TableCell>
                <TableCell align="center" sx={bodyCellStyles}>
                  {row.price}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Note Section */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        {t("pricing.note.title")}
      </Typography>
      <ul>
        {t("pricing.note.items", { returnObjects: true }).map((item, index) => (
          <li key={index} style={{ direction, textAlign }}>
            <Typography
              style={{ direction, textAlign }}
              sx={{
                color: "#1D1616",
                fontSize: { xs: "1.1rem", lg: "1.4rem" },
              }}
              variant="body1"
            >
              {item}
            </Typography>
          </li>
        ))}
      </ul>
      {/* Attention Section */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        {t("Attention")}
      </Typography>
      <ul>
        <Typography
          style={{ direction, textAlign }}
          sx={{
            color: "#1D1616",
            fontSize: { xs: "1.1rem", lg: "1.4rem" },
          }}
          variant="body1"
        >
          {t("AttentionDisc")}
        </Typography>
      </ul>

      {/* Address Section */}
      <Typography
        style={{ direction, textAlign }}
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "30px",
          },
        }}
      >
        {t("pricing.address.title")}
      </Typography>
      <Typography
        style={{ direction, textAlign }}
        sx={{
          color: "#1D1616",
          fontSize: { xs: "1.1rem", lg: "1.4rem" },
        }}
        variant="body1"
      >
        {t("pricing.address.company")}
      </Typography>
      <Typography
        style={{ direction, textAlign }}
        sx={{
          color: "#1D1616",
          fontSize: { xs: "1.1rem", lg: "1.4rem" },
        }}
        variant="body1"
      >
        {t("pricing.address.location")}
      </Typography>

      <ContactChat />
    </Box>
  );
};

export default Payment;
